// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Icon, Space, Styled} from '@supermove/components';
import {useResponsive} from '@supermove/hooks';
import {colors} from '@supermove/styles';

// Shared
import FieldInput from '@shared/design/components/Field/FieldInput';
import Line from '@shared/design/components/Line';
import TextTooltip from '@shared/design/components/TextTooltip';
import ResponsiveTextInput from '@shared/modules/App/components/ResponsiveTextInput';
import {FormikCommentFormType} from '@shared/modules/Comment/forms/CommentForm';

const CommentInputContainer = Styled.View`
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  background-color: ${colors.white};
  min-height: 48px;
  padding-top: 6px;
  padding-bottom: 6px;
`;

const SendButton = Styled.ButtonV2<{disabled: boolean}>`
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background-color: ${({disabled}) => (disabled ? colors.gray.disabled : colors.blue.interactive)};
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

const ProjectCommentInput = ({
  form,
  handleSubmit,
}: {
  form: FormikCommentFormType;
  handleSubmit: () => void;
}) => {
  const responsive = useResponsive();
  const isSendDisabled = _.isEmpty(form.values.commentForm.subject);

  return (
    <React.Fragment>
      <FieldInput
        {...form}
        name={'commentForm.subject'}
        handleCommandEnter={handleSubmit}
        showErrorMessage={false}
        isResponsive
        input={{
          autoFocus: true,
          placeholder: 'Subject',
          style: {
            borderWidth: 0,
            paddingTop: 4,
            height: 48,
          },
        }}
        style={{flex: 1}}
      />
      <Line />
      <CommentInputContainer>
        <FieldInput
          {...form}
          name={'commentForm.body'}
          handleCommandEnter={handleSubmit}
          component={ResponsiveTextInput}
          isResponsive
          input={{
            placeholder: 'Add comment',
            style: {
              borderWidth: 0,
            },
          }}
          style={{flex: 1}}
        />
        <Space width={12} />
        <TextTooltip text={isSendDisabled ? 'Add a subject to send' : undefined}>
          <SendButton
            disabled={isSendDisabled}
            onPress={handleSubmit}
            hitSlop={{top: 8, bottom: 8, left: 8, right: 8}}
          >
            <Icon source={Icon.ArrowUp} size={responsive.desktop ? 12 : 16} color={colors.white} />
          </SendButton>
        </TextTooltip>
        <Space width={12} />
      </CommentInputContainer>
    </React.Fragment>
  );
};

export default ProjectCommentInput;
